/* eslint-env browser */
/*
 * Like id7-bundle.js but with a real "I know best" feel to it
 * Tries not to include anything on the critical path unless it needs to
 */

// Expose jQuery to window and for attaching plugins

import { consola } from 'consola';

import './global-exports';

// Bootstrap plugins required for ID7 or common page types
import '@universityofwarwick/id7/js/bootstrap-transition.jquery'; // Dependency of modals (page owner)
// import '@universityofwarwick/id7/js/bootstrap-alert.jquery';
import '@universityofwarwick/id7/js/bootstrap-button.jquery';     // Used on Economics' site, work with Economics if we want to remove
import '@universityofwarwick/id7/js/bootstrap-carousel.jquery';   // WCT-delivered slideshows
import '@universityofwarwick/id7/js/bootstrap-collapse.jquery';   // Collapsing content, accordions, widely used
import '@universityofwarwick/id7/js/bootstrap-dropdown.jquery';   // Warwick Forums
import '@universityofwarwick/id7/js/bootstrap-modal.jquery';      // Contact the page owner
import '@universityofwarwick/id7/js/bootstrap-tooltip.jquery';    // Dependency of popovers
import '@universityofwarwick/id7/js/bootstrap-popover.jquery';    // Glossary pages
import '@universityofwarwick/id7/js/bootstrap-tab.jquery';        // Tabs (e.g. course pages)
import '@universityofwarwick/id7/js/bootstrap-affix.jquery';      // ID7 navigation
import '@universityofwarwick/id7/js/bootstrap-3-typeahead.jquery';
import 'headroom.js/dist/jQuery.headroom';             // ID7 navigation

import '@universityofwarwick/id7/js/id7-default-feature-detect';
import '@universityofwarwick/id7/js/reflow-event.jquery';
import '@universityofwarwick/id7/js/account-popover.jquery';
import '@universityofwarwick/id7/js/navigation.jquery';
import '@universityofwarwick/id7/js/search-suggest.jquery';
import '@universityofwarwick/id7/js/wide-tables.jquery';
import '@universityofwarwick/id7/js/jquery-focussable';
import '@universityofwarwick/id7/js/site-links';

// Used by wide-tables
import '@universityofwarwick/jqdoublescroll';

// Legacy Event.onDOMReady(), StringBuilder and other content support scripts
import '../../scripts/scraps-jquery.js';

// ID7-specific content support scripts
import '../../scripts/scraps-jquery-id7.js';

// Keyboard shortcuts
import '../../scripts/shortcuts-jquery.js';

// HTML5 Audio player - custom controls
import '../../scripts/libs/html5audio-jquery.js';

import '../../scripts/libs/glossary-jquery.js';
import '../../scripts/libs/sortableTables.js';
import '../../scripts/comments-jquery.js';
import '../../scripts/map-jquery.js';
import '../../scripts/twitter-widget-load.js';
import '../../scripts/popoverShim.js';

import { debounce } from 'lodash';

consola.box('ID7 render bundle');

// lodash for legacy content. Whitelist of functions
window._ = {
  debounce,
};

// REMOVED: moment.js
window.moment = function () {
  return {
    format: () => '',
  };
};

